import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=597ab3ba&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=597ab3ba&prod&lang=scss&"
import style1 from "./detail.vue?vue&type=style&index=1&id=597ab3ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597ab3ba",
  null
  
)

export default component.exports